import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const ORDER: AppRouteRecordRaw = {
  path: '/order',
  name: 'Order',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.order',
    requiresAuth: true,
    icon: 'icon-list',
    order: 3,
  },
  children: [
    {
      path: 'list',
      name: 'OrderList',
      component: () => import('@/views/order/list/index.vue'),
      meta: {
        locale: 'menu.order.list',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'subscription-order-list',
      name: 'SubscriptionOrderList',
      component: () => import('@/views/order/subscription-order-list/index.vue'),
      meta: {
        locale: 'menu.order.subscriptionOrderList',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'email-template',
      name: 'EmailTemplate',
      component: () => import('@/views/order/email-template/index.vue'),
      meta: {
        locale: 'menu.order.emailTemplate',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    // 旧路径兼容
    {
      path: 'subscription',
      name: 'SubscriptionListLegacy',
      redirect: { name: 'SubscriptionList' },
      meta: {
        locale: 'menu.subscription.list',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'export-records',
      name: 'ExportRecordsLegacy',
      redirect: { name: 'ExportRecords' },
      meta: {
        locale: 'menu.exportRecords',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
  ],
};

export default ORDER;
